import {
  GET_ALL_TRANSPORT_GROUPS,
  GET_TRANSPORT_AREAS,
  GET_TRANSPORT_SLABS,
  GET_STUDENTS_FOR_TRANSPORT_AREA,
} from 'actions/admin/transportFee';

const initialState = {
  transportGroups: [],
  // Keyed by transportFeeStructId
  transportAreasByGroup: {},
  transportSlabsByGroup: {},
  // Keyed by transportAreaId
  studentsByArea: {},
};

export default function transportFee(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ALL_TRANSPORT_GROUPS: {
      return { ...state, transportGroups: action.transportGroups };
    }
    case GET_TRANSPORT_AREAS: {
      return {
        ...state,
        transportAreasByGroup: { ...state.transportAreasByGroup, [action.transportFeeStructId]: action.transportAreas },
      };
    }
    case GET_TRANSPORT_SLABS: {
      return {
        ...state,
        transportSlabsByGroup: { ...state.transportSlabsByGroup, [action.transportFeeStructId]: action.transportSlabs },
      };
    }
    case GET_STUDENTS_FOR_TRANSPORT_AREA: {
      return {
        ...state,
        studentsByArea: { ...state.studentsByArea, [action.transportAreaId]: action.students },
      };
    }
    default:
      return state;
  }
}
